import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Paper,
  TextField,
  Grid,
  Typography,
  CircularProgress
} from '@mui/material';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import { useNavigate } from 'react-router-dom';

function SalesReports() {
  const [salesByDistributor, setSalesByDistributor] = useState([]);
  const [salesByLottery, setSalesByLottery] = useState([]);
  const [dailySales, setDailySales] = useState([]);
  const [distributorFilter, setDistributorFilter] = useState('');
  const [lotteryFilter, setLotteryFilter] = useState('');
  const [fromDateFilter, setFromDateFilter] = useState('');
  const [toDateFilter, setToDateFilter] = useState('');
  const [loading, setLoading] = useState(true);
  
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch distributor sales summary
        const distributorResponse = await fetch('https://servermunidasa.ccsoftwares.com/report/getSalesSummaryByDistributor');
        if (!distributorResponse.ok) throw new Error('Network response was not ok');
        const distributorData = await distributorResponse.json();
        console.log(distributorData)
        setSalesByDistributor(distributorData);

        // Fetch lottery sales summary
        const lotteryResponse = await fetch('https://servermunidasa.ccsoftwares.com/report/getSalesSummaryByLottery');
        if (!lotteryResponse.ok) throw new Error('Network response was not ok');
        const lotteryData = await lotteryResponse.json();
        console.log('lot data',lotteryData)
        setSalesByLottery(lotteryData);

        // Fetch daily sales summary
        const dailyResponse = await fetch('https://servermunidasa.ccsoftwares.com/report/getSalesDaily');
        if (!dailyResponse.ok) throw new Error('Network response was not ok');
        const dailyData = await dailyResponse.json();
        setDailySales(dailyData);

        setLoading(false); // Data loaded successfully
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false); // Stop loading on error
      }
    };

    fetchData();
  }, []);

  const downloadDistributorReport = () => {
    const pdf = new jsPDF();
    pdf.setFontSize(16);
    pdf.setFont("helvetica", "bold");
    pdf.text("M.M.Munidasa Lottery Agency", pdf.internal.pageSize.getWidth() / 2, 25, { align: 'center' });
    pdf.setFontSize(12);
    pdf.setFont("helvetica", "normal");

    const addressLines = [
      "175/23/E, Mahawatta Road,",
      "Pelanwatta, Pannipitiya",
      "Tel. (+94) 788 393 515"
    ];
    addressLines.forEach((line, index) => {
      pdf.text(line, pdf.internal.pageSize.getWidth() / 2, 35 + (index * 10), { align: 'center' });
    });

    pdf.text("Sales Summary by Distributor", 14, 60);
    pdf.autoTable({ html: '#distributorTable', startY: 65 });
    pdf.save('sales_summary_by_distributor.pdf');
  };

  const downloadLotteryReport = () => {
    const pdf = new jsPDF();
    pdf.setFontSize(16);
    pdf.setFont("helvetica", "bold");
    pdf.text("M.M.Munidasa Lottery Agency", pdf.internal.pageSize.getWidth() / 2, 25, { align: 'center' });
    pdf.setFontSize(12);
    pdf.setFont("helvetica", "normal");

    const addressLines = [
      "175/23/E, Mahawatta Road,",
      "Pelanwatta, Pannipitiya",
      "Tel. (+94) 788 393 515"
    ];
    addressLines.forEach((line, index) => {
      pdf.text(line, pdf.internal.pageSize.getWidth() / 2, 35 + (index * 10), { align: 'center' });
    });

    pdf.text("Sales Summary by Lottery", 14, 60);
    pdf.autoTable({ html: '#lotteryTable', startY: 65 });
    pdf.save('sales_summary_by_lottery.pdf');
  };

  const downloadDailySalesReport = () => {
    const pdf = new jsPDF();
    pdf.setFontSize(16);
    pdf.setFont("helvetica", "bold");
    pdf.text("M.M.Munidasa Lottery Agency", pdf.internal.pageSize.getWidth() / 2, 25, { align: 'center' });
    pdf.setFontSize(12);
    pdf.setFont("helvetica", "normal");

    const addressLines = [
      "175/23/E, Mahawatta Road,",
      "Pelanwatta, Pannipitiya",
      "Tel. (+94) 788 393 515"
    ];
    addressLines.forEach((line, index) => {
      pdf.text(line, pdf.internal.pageSize.getWidth() / 2, 35 + (index * 10), { align: 'center' });
    });

    pdf.text("Daily Sales Summary", 14, 60);
    pdf.autoTable({ html: '#dailySalesTable', startY: 65 });
    pdf.save('daily_sales_summary.pdf');
  };

  return (
    <div>
      <Grid xs = {12} md = {12}>
            <div style={{display : 'flex',alignItems : 'center',justifyContent : 'left',height : 40}}>
            <button
            style={{
                    backgroundColor : 'transparent',
                    color: 'Black',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: 30,
                    marginTop : 10
                }}
                onClick={() => navigate(-1)}
            >
          <ArrowCircleLeftIcon fontSize='2'/>
        </button>
            <div style={{fontFamily : 'Segoe UI',fontSize : 28,fontWeight : '400'}}>
               Sales Reports
            </div>
        </div>

        </Grid>

      {/* Daily Sales Summary Table */}
      <TableContainer component={Paper} style={{ maxHeight: '500px', overflowY: 'auto', marginBottom: '20px',marginTop :20 }}>
        <Grid container justifyContent="space-between" alignItems="center" style={{ padding: '16px' }}>
          <Grid item>
            <Typography variant="h6">Daily Sales Summary</Typography>
          </Grid>
          <Grid item>
            <TextField
              type="date"
              value={fromDateFilter}
              onChange={(e) => setFromDateFilter(e.target.value)}
              variant="outlined"
              size="small"
              style={{ marginRight: 10 }}
            />
            <TextField
              type="date"
              value={toDateFilter}
              onChange={(e) => setToDateFilter(e.target.value)}
              variant="outlined"
              size="small"
            />
            <Button variant="contained" color="primary" onClick={downloadDailySalesReport} style={{ marginLeft: 10 }}>
              Download PDF
            </Button>
          </Grid>
        </Grid>
        {loading ? (
          <CircularProgress />
        ) : (
          <Table id="dailySalesTable" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Draw Date</TableCell>
                <TableCell>Total Revenue</TableCell>
                <TableCell>Total Cost</TableCell>
                <TableCell>Profit</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dailySales
                .filter(row => {
                  const selectedFromDate = new Date(fromDateFilter);
                  const selectedToDate = new Date(toDateFilter);
                  // const drawDate = new Date(row.drawDate);
                  console.log('saily sales ',row)
                  return (
                    (fromDateFilter === '' || row.drawDate >= selectedFromDate) &&
                    (toDateFilter === '' || row.drawDate <= selectedToDate)
                  );
                })
                .map((row) => (
                  <TableRow key={row.drawDate}>
                    <TableCell>{new Date(row.drawDate).toLocaleDateString()}</TableCell>
                    <TableCell>{row.TotalRevenue}</TableCell>
                    <TableCell>{row.TotalCost}</TableCell>
                    <TableCell>{row.Profit}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        )}
      </TableContainer>

      {/* Sales Summary by Distributor Table */}
      <TableContainer component={Paper} style={{ maxHeight: '500px', overflowY: 'auto', marginBottom: '20px' }}>
        <Grid container justifyContent="space-between" alignItems="center" style={{ padding: '16px' }}>
          <Grid item>
            <Typography variant="h6">Sales Summary by Distributor</Typography>
          </Grid>
          <Grid item>
            <TextField
              label="Filter by Distributor ID or Name"
              variant="outlined"
              size="small"
              value={distributorFilter}
              onChange={(e) => setDistributorFilter(e.target.value)}
              style={{marginRight : 10}}
            />
            <TextField
              type="date"
              value={fromDateFilter}
              onChange={(e) => setFromDateFilter(e.target.value)}
              variant="outlined"
              size="small"
              style={{ marginRight: 10 }}
            />
            <TextField
              type="date"
              value={toDateFilter}
              onChange={(e) => setToDateFilter(e.target.value)}
              variant="outlined"
              size="small"
            />
            <Button variant="contained" color="primary" onClick={downloadDistributorReport} style={{ marginLeft: 10 }}>
              Download PDF
            </Button>
          </Grid>
        </Grid>
        {loading ? (
          <CircularProgress />
        ) : (
          <Table id="distributorTable" stickyHeader>
            <TableHead>
            <TableRow>
                 <TableCell>Invoice No</TableCell>
                 <TableCell>Distributor ID</TableCell>
                 <TableCell>Distributor</TableCell>
                 <TableCell>Total Qty</TableCell>
                 <TableCell>Total Revenue</TableCell>
                 <TableCell>Total Cost</TableCell>
                 <TableCell>Profit</TableCell>
                 <TableCell>Date</TableCell>
               </TableRow>
            </TableHead>
            <TableBody>
            {salesByDistributor
              .filter(row => {
                const selectedFromDate = new Date(fromDateFilter);
                const selectedToDate = new Date(toDateFilter);
                const drawDate = new Date(row.DrawDate); // Convert DrawDate to a Date object

                return (
                  (fromDateFilter === '' || drawDate >= selectedFromDate) &&
                  (toDateFilter === '' || drawDate <= selectedToDate) &&
                  (distributorFilter === '' || 
                  row.distId.includes(distributorFilter) || 
                  row.full_name.toLowerCase().includes(distributorFilter.toLowerCase()))
                );
              })
              .map((row) => (
                <TableRow key={row.inv_no}>
                  <TableCell>{row.inv_no}</TableCell>
                  <TableCell>{row.distId}</TableCell>
                  <TableCell>{row.full_name}</TableCell>
                  <TableCell>{row.TotalQty}</TableCell>
                  <TableCell>{row.TotalRevenue}</TableCell>
                  <TableCell>{row.TotalCost}</TableCell>
                  <TableCell>{row.Profit}</TableCell>
                  <TableCell>{row.DrawDate}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </TableContainer>

      {/* Sales Summary by Lottery Table */}
      <TableContainer component={Paper} style={{ maxHeight: '500px', overflowY: 'auto' }}>
        <Grid container justifyContent="space-between" alignItems="center" style={{ padding: '16px' }}>
          <Grid item>
            <Typography variant="h6">Sales Summary by Lottery</Typography>
          </Grid>
          <Grid item>
            <TextField
              label="Filter by Lottery Name"
              variant="outlined"
              size="small"
              value={lotteryFilter}
              onChange={(e) => setLotteryFilter(e.target.value)}
              style={{marginRight : 10}}
            />
            <TextField
              type="date"
              value={fromDateFilter}
              onChange={(e) => setFromDateFilter(e.target.value)}
              variant="outlined"
              size="small"
              style={{ marginRight: 10 }}
            />
            <TextField
              type="date"
              value={toDateFilter}
              onChange={(e) => setToDateFilter(e.target.value)}
              variant="outlined"
              size="small"
            />
            <Button variant="contained" color="primary" onClick={downloadLotteryReport} style={{ marginLeft: 10 }}>
              Download PDF
            </Button>
          </Grid>
        </Grid>
        {loading ? (
          <CircularProgress />
        ) : (
          <Table id="lotteryTable" stickyHeader>
            <TableHead>
            <TableRow>
                <TableCell>Lottery Name</TableCell>
                <TableCell>Total Qty</TableCell>
                <TableCell>Total Revenue</TableCell>
                <TableCell>Total Cost</TableCell>
                <TableCell>Profit</TableCell>
                <TableCell>Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {salesByLottery
                .filter(row => {
                  const selectedFromDate = new Date(fromDateFilter);
                  const selectedToDate = new Date(toDateFilter);
                  console.log(row)
                  return (
                    (fromDateFilter === '' || row.DrawDate >= selectedFromDate) &&
                    (toDateFilter === '' || row.DrawDate <= selectedToDate) &&
                    (lotteryFilter === '' || row.lotteryName.toLowerCase().includes(lotteryFilter.toLowerCase()))
                  );
                })
                .map((row) => (
                    <TableRow key={row.LotteryName}>
                     <TableCell>{row.LotteryName}</TableCell>
                     <TableCell>{row.TotalSold}</TableCell>
                     <TableCell>{row.TotalRevenue}</TableCell>
                     <TableCell>{row.TotalCost}</TableCell>
                     <TableCell>{row.Profit}</TableCell>
                     <TableCell>{row.DrawDate}</TableCell>
                   </TableRow>
                ))}
            </TableBody>
          </Table>
        )}
      </TableContainer>
    </div>
  );
}

export default SalesReports;


